/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { createSlice } from '@reduxjs/toolkit';  
import { getAllOrgApplicationAuthProviders, getAllOrgsAppsAuthProvidersByOrgID, getOrgAppAuthProviderHistory } from './orgAppAuthProviderAction'; 
 
const initialState = {
    data: {},
    orgAppAuthProviders: {},
    orgAppAuthProviderHistory: {}
}
const orgAppAuthProviderSlice = createSlice({
    name: 'orgAppAuthProvider',
    initialState,
    extraReducers: {

        [getAllOrgApplicationAuthProviders.fulfilled]: (state, { payload }) => {
            state.orgAppAuthProviders =  payload;
        },
        [getAllOrgsAppsAuthProvidersByOrgID.fulfilled]: (state, { payload }) => {
            state.orgAppAuthProviders =  payload;
        },
        [getOrgAppAuthProviderHistory.fulfilled]: (state, { payload }) => {
            state.orgAppAuthProviderHistory =  payload;
        },
        [getOrgAppAuthProviderHistory.rejected]: (state, { payload }) => {
            state.orgAppAuthProviderHistory =  {};
        },
    }
});

export default orgAppAuthProviderSlice.reducer